module.exports = __webpack_public_path__ + "static/img/west-city2.553cc0ce.png";